import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ShortObject} from '../../project-misc/data/project/short-json-object';

@JsonObject('model.modifierId')
export class ModifierId extends AbstractModel {
  @JsonProperty(Number, 'itemId')
  itemId?: number

  @JsonProperty(Number, 'modifierId')
  modifierId?: number
}

@JsonObject('model.PricingCustomField')
export class PricingCustomField extends AbstractModel {
  @JsonProperty(ModifierId, 'id')
  id?: ModifierId

  @JsonProperty(ShortObject, 'item')
  item?: ShortObject

  @JsonProperty(ShortObject, 'modifier')
  modifier?: ShortObject

  @JsonProperty(Boolean, 'value')
  value?: boolean
}

